import { useState, useEffect } from 'react'
import Papa from 'papaparse'

export function useDate() {
  const [endDate, setEndDate] = useState<string>()

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard-2023/version.json'
    )
      .then((a) => a.json())
      .then((a) => {
        setEndDate(a.date)
      })
  }, [])

  useEffect(() => {
    fetch(
      'https://docs.google.com/spreadsheets/d/e/2PACX-1vRwkNU44Lwb7WyJh5JDzw5svcR-PV-ohFOzFkByHQXw4axCL8GaTv-xaaHyr-ZKKoBKfndmtCWol44r/pub?gid=0&single=true&output=csv'
    )
      .then((a) => a.text())
      .then((a) => {
        var parsed = Papa.parse(a, { header: true }) as any
        var sheetdate = parsed.data[0].date as string
        if (!endDate || new Date(sheetdate) > new Date(endDate))
          setEndDate(sheetdate)
      })
  }, [endDate])
  return endDate || 'undefined'
}
